module.exports = __webpack_public_path__ + "img/investOneMob.49fb82ee.svg";